import { FreeTrialsTypes } from '.';

export const freeTrialsQueryKeys = {
  isFreeTrialEligible: (featureEnum: FreeTrialsTypes.Feature) => [featureEnum, 'is-free-trial-eligible'],
  getTrialStageBanner: ['get-trial-stage-banner'],
  getTrialHistory: ['get-trial-history'],
  updateTrialBannerUserAction: (locationId: string) => [locationId, 'update-trial-banner-user-action'],
  freeTrialSignUp: (locationId: string) => [locationId, 'free-trial-signup'],
};
